import React, { useState, useRef } from "react";
import { Button, Dropdown, Menu, Tooltip } from "antd";
import { ReactComponent as FilterIcon } from "../../../assets/Icons/filterIcon.svg";
import "./CustomFilterDropdown.scss";

const EllipsisTooltip = ({ text }) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);

  const checkTruncation = () => {
    if (textRef.current) {
      const element = textRef.current;
      const parent = element.parentElement;
      const isSelfOver = element.scrollWidth > element.clientWidth;
      const isParentOver = parent ? parent.scrollWidth > parent.clientWidth : false;
      setIsTruncated(isSelfOver || isParentOver);
    }
  };

  return (
    <Tooltip title={isTruncated ? text : ""} mouseEnterDelay={0.3}>
      <span
        ref={textRef}
        onMouseEnter={checkTruncation}
        style={{
          display: "block",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "100%",
        }}
      >
        {text}
      </span>
    </Tooltip>
  );
};

const CustomFilterDropdown = ({
  buttonLabel = "Category",
  options = [],
  onChange,
  defaultValue = null,
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const [isOpen, setIsOpen] = useState(false);

  const handleMenuClick = (e) => {
    const value = e.key;
    setSelectedValue(value);
    onChange?.(value);
    setIsOpen(false); // close after selection
  };

  const menu = (
    <Menu
      className="custom-dropdown-menu"
      onClick={handleMenuClick}
      selectedKeys={[selectedValue]}
      items={options.map((item) => ({
        key: item.value,
        label: <EllipsisTooltip text={item.label || ""} />,
      }))}
    />
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      overlayClassName="custom-dropdown-wrapper"
      onOpenChange={(open) => setIsOpen(open)}
    >
      <Button className={`dropdown-button ${isOpen ? "active" : ""}`}>
        <FilterIcon className="filter-icon" />
        <span>{buttonLabel}</span>
      </Button>
    </Dropdown>
  );
};

export default CustomFilterDropdown;

